import React, { memo, PropsWithChildren } from 'react'

import { RestQueryClientProvider } from '@affiliate-cabinet/rest'

export const AppRestQueryClientProvider = memo(({ children }: PropsWithChildren) => <RestQueryClientProvider>{children}</RestQueryClientProvider>)
AppRestQueryClientProvider.displayName = 'AppRestQueryClientProvider'
